<div class="app-content content">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
        <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
      </div>
      <div class="content-body">
        <section id="offers-active">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h5 class="content-header-title card-title">Consulta el listado de ofertas de trabajo creadas por ti, que se validaron para ser publicadas y que actualmente se encuentran activas.</h5>
              </div>
              <div class="table-responsive card-body">
                <div *ngIf="response?.data === null || response?.data.length === 0"
                class="bs-callout-info callout-round callout-bordered mt-1">
                  <div class="media align-items-stretch">
                    <div class="d-flex align-items-center media-left media-middle bg-info callout-arrow-left position-relative p-2">
                      <i class="la la-ban white font-medium-5"></i>
                    </div>
                    <div class="media-body p-1">
                      <h4 class="info">No se han publicado ofertas tuyas</h4>
                      <p>Todavía no hay registro de ofertas creadas por ti que hayan sido válidas para ser publicadas, por lo que no hay información que mostrar.
                      Si ya creaste ofertas y se encuentran en proceso de revisión, al ser validadas podrás consultarlas aquí.
                      </p>
                    </div>
                  </div>
                </div>

                <table *ngIf="response?.data != null || response?.data.length > 0"
                class="table table-column table-hover">
                  <thead class="thead bg-blue1">
                    <tr>                      
                      <th scope="col">
                        <h5 class="text-bold-600">Puesto</h5></th>
                      <th scope="col">
                        <h5 class="text-bold-600">Lugar</h5></th>
                      <th scope="col">
                        <h5 class="text-bold-600">Área</h5></th>
                      <th scope="col">
                        <h5 class="text-bold-600">Especialidad</h5></th>
                      <th scope="col">
                        <h5 class="text-bold-600">Detalles</h5></th>
                      <th scope="col">
                        <h5 class="text-bold-600">No. Postulantes</h5></th>
                      <th scope="col">
                        <h5 class="text-bold-600">Ver Postulantes</h5></th>
                      <th scope="col">
                        </th>
                      </tr>
                  </thead>
                  <tbody *ngFor="let oferta of response?.data;">
                    <tr *ngIf="!oferta.deleted"  class="ng-star-inserted">
                      <th scope="row">{{ oferta.descripcionPuesto }}</th>
                      <td scope="row">{{ oferta.lugar }}</td>
                      <td scope="row">{{ oferta.division }}</td>                       
                      <td scope="row">{{ oferta.area }}</td>
                      <td scope="row" class="text-center">
                        <button type="button" class="btn btn-icon btn-primary mr-1" (click)="openDetailOffer(oferta?.idOferta)"
                        triggers="hover:click:hover" placement="top"
                        ngbPopover="Consulta información más detallada acerca de la oferta de trabajo. Entérate del perfil y los conocimientos solicitados, así como las responsabilidades del puesto, entre otros datos."
                        popoverTitle="Detalles de la Oferta">
                          <i class="feather ft-eye"></i>
                        </button>
                      </td>
                      <td scope="row">{{ oferta.numeroPostulantes }}</td>
                      <td scope="row" class="text-center">
                        <button [disabled]="oferta.numeroPostulantes === 0" (click)="seePostulantes(oferta)" type="button" class="btn btn-icon btn-warning mr-1"
                        triggers="hover:click:hover" placement="top"
                        ngbPopover="Consulta la lista de postulados a una oferta. Conoce su información personal y su perfil profesional."
                        popoverTitle="Postulantes de la Oferta">
                          <i class="feather ft-users"></i>
                        </button>
                      </td>
                      <td scope="row" class="text-center">
                        <button type="button" class="btn btn-icon btn-danger mr-1" (click)="openModalConfirmation(oferta)"
                        triggers="hover:click:hover" placement="top"
                        ngbPopover="Cancela la publicación de una oferta para no recibir más postulantes."
                        popoverTitle="Cancelar Oferta">
                          <i class="feather ft-trash-2"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
  
                <!--Paginador-->
                <div *ngIf="response?.data != null && response?.totalPages > 1"
                class="d-flex justify-content-between p-2">
                  <div class="col-lg-6 col-md-12">
                    <nav aria-label="Navegador de páginas">
                      <ul class="pagination justify-content-star pagination-separate ">
                        <ngb-pagination 
                        [(page)]="currentPage" 
                        [collectionSize]="response?.totalRows" 
                        [pageSize]="response?.pageSize" 
                        (pageChange)="pageChange($event)"
                        class="d-flex justify-content-start"></ngb-pagination>
                      </ul>
                    </nav>              
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <br><br><br>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
